<template>
  <div class="bg-surface flex w-full flex-col items-center justify-center">
    <OrganizationSessionBar />
    <div class="flex w-full grow flex-col items-center justify-center px-4">
      <div
        class="bg-surface-container-lowest rounded-extra-large flex w-full max-w-2xl flex-col gap-2 p-6 md:p-8"
      >
        <div class="relative mx-auto mb-6 h-32 w-32">
          <BaseShape shape="7-sided-cookie" class="text-primary-container h-full w-full" />
          <BaseIcon
            size="48"
            class="text-on-primary-container absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
            >home_work</BaseIcon
          >
        </div>
        <h2 class="md:text-display-small text-headline-medium">
          {{ $t('organization.join.title') }}
        </h2>
        <p class="text-body-large text-on-surface-variant">
          {{ $t('organization.join.description', { name: organization.name }) }}
        </p>
        <div class="bg-surface rounded-large text-on-surface-variant mt-2 p-4">
          <h4 class="text-title-small">{{ $t('organization.join.info.title') }}</h4>
          <ul class="text-body-medium mt-2 list-disc space-y-1 pl-5">
            <li>{{ $t('organization.join.info.visibility') }}</li>
            <li>{{ $t('organization.join.info.access') }}</li>
          </ul>
        </div>
        <div class="mt-6 flex flex-row justify-end">
          <BaseTextButton
            class="w-full"
            color="filled"
            :size="{ base: 'M', md: 'L' }"
            :disabled="acceptStatus === ApiRequestStatus.Loading"
            @click="acceptOrganization"
          >
            {{ $t('organization.join.accept', { name: organization.name }) }}
          </BaseTextButton>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'
  import { ApiRequestStatus } from '@/core/models/api/api-request-status'
  import { useJoinOrganization } from '../composables/use-join-organization'
  import OrganizationSessionBar from '../components/OrganizationSessionBar.vue'

  const { organization, acceptStatus, acceptOrganization } = useJoinOrganization()
</script>
